import { Nullable } from 'utils/types';

export enum FIELDS {
  APPLICANT_1 = 'APPLICANT_1',
  APPLICANT_2 = 'APPLICANT_2',
  //General section
  CASE_ID = 'CASE_ID',
  ORIGINATION_ID = 'ORIGINATION_ID',
  NUMBER_OF_APPLICANTS = 'NUMBER_OF_APPLICANTS',
  ACCOUNT_NUMBER = 'ACCOUNT_NUMBER',
  SORT_CODE = 'SORT_CODE',
  //Mortgage Property section
  TITLE_NUMBER = 'TITLE_NUMBER',
  FLAT_NUMBER = 'FLAT_NUMBER',
  BUILDING_NAME = 'BUILDING_NAME',
  BUILDING_NUMBER = 'BUILDING_NUMBER',
  STREET = 'STREET',
  CITY = 'CITY',
  PROPERTY_POST_CODE = 'PROPERTY_POST_CODE',
  PROPERTY_TYPE = 'PROPERTY_TYPE',
  TENURE = 'TENURE',
  PROPERTY_BUILT_YEAR = 'PROPERTY_BUILT_YEAR',
  ACTUAL_PROPERTY_VALUE = 'ACTUAL_PROPERTY_VALUE',
  INSPECTION_DATE = 'INSPECTION_DATE',
  //Loan section
  PEPPER_PURPOSE_OF_THE_LOAN = 'PEPPER_PURPOSE_OF_THE_LOAN',
  FCA_LOAN_PURPOSE = 'FCA_LOAN_PURPOSE',
  NET_LOAN = 'NET_LOAN',
  IS_BUY_TO_LET = 'IS_BUY_TO_LET',
  IS_MARGIN_ACTIVE = 'IS_MARGIN_ACTIVE',
  IS_APP_ACTIVE = 'IS_APP_ACTIVE',
  PRODUCT_FEE = 'PRODUCT_FEE',
  PRODUCT_FEE_PAYMENT = 'PRODUCT_FEE_PAYMENT',
  COMPLETION_DATE = 'COMPLETION_DATE',
  VARIABLE_TERM_START_DATE = 'VARIABLE_TERM_START_DATE',
  NUMBER_OF_PAYMENTS = 'NUMBER_OF_PAYMENTS',
  FIXED_INTEREST_RATE = 'FIXED_INTEREST_RATE',
  REVERT_MARGIN = 'REVERT_MARGIN',
  LVR = 'LVR',
  BORROWER_NAME = 'BORROWER_NAME',
  BORROWER_CONTACT = 'BORROWER_CONTACT',
  CONTACT_VALUE = 'CONTACT_VALUE',
  BORROWER_LAST_NAME = 'BORROWER_LAST_NAME',
  BORROWER_FIRST_NAME = 'BORROWER_FIRST_NAME',
  BORROWER_TITLE = 'BORROWER_TITLE',
  BORROWER_DATE_OF_BIRTH = 'BORROWER_DATE_OF_BIRTH',
  BORROWER_GENDER = 'BORROWER_GENDER',
  BORROWER_EMPLOYMENT_STATUS = 'BORROWER_EMPLOYMENT_STATUS',
  BORROWER_TOTAL_CURRENT_INCOME = 'BORROWER_TOTAL_CURRENT_INCOME',
  BORROWER_EMAIL = 'BORROWER_EMAIL',
  BORROWER_ADDITIONAL_EMAIL = 'BORROWER_ADDITIONAL_EMAIL',
  BORROWER_PHONE_HOME = 'BORROWER_PHONE_HOME',
  BORROWER_PHONE_MOBILE = 'BORROWER_PHONE_MOBILE',
  BORROWER_PHONE_WORK = 'BORROWER_PHONE_WORK',
}

export enum SUBDOMAINS {
  GENERAL = 'general',
  MORTGAGE_PROPERTY = 'mortgageProperty',
  LOAN = 'loan',
  BORROWER = 'borrower',
}

export type ApplicantRelated<T> = {
  [FIELDS.APPLICANT_1]: T;
  [FIELDS.APPLICANT_2]: Nullable<T>;
};

export type GeneralSection = {
  [FIELDS.CASE_ID]: Nullable<string>;
  [FIELDS.ORIGINATION_ID]: Nullable<string>;
  [FIELDS.NUMBER_OF_APPLICANTS]: Nullable<number>;
  [FIELDS.ACCOUNT_NUMBER]: Nullable<number>;
  [FIELDS.SORT_CODE]: Nullable<string>;
};

export type MortgagePropertySection = {
  [FIELDS.TITLE_NUMBER]: Nullable<string>;
  [FIELDS.FLAT_NUMBER]: Nullable<string>;
  [FIELDS.BUILDING_NAME]: Nullable<string>;
  [FIELDS.BUILDING_NUMBER]: Nullable<string>;
  [FIELDS.STREET]: Nullable<string>;
  [FIELDS.CITY]: Nullable<string>;
  [FIELDS.PROPERTY_POST_CODE]: Nullable<string>;
  [FIELDS.PROPERTY_TYPE]: Nullable<string>;
  [FIELDS.TENURE]: Nullable<string>;
  [FIELDS.PROPERTY_BUILT_YEAR]: Nullable<number>;
  [FIELDS.ACTUAL_PROPERTY_VALUE]: Nullable<number>;
  [FIELDS.INSPECTION_DATE]: Nullable<string>;
};

export type LoanSection = {
  [FIELDS.PEPPER_PURPOSE_OF_THE_LOAN]: Nullable<string>;
  [FIELDS.FCA_LOAN_PURPOSE]: Nullable<string>;
  [FIELDS.NET_LOAN]: Nullable<number>;
  [FIELDS.IS_BUY_TO_LET]: Nullable<boolean>;
  [FIELDS.IS_MARGIN_ACTIVE]: Nullable<boolean>;
  [FIELDS.IS_APP_ACTIVE]: Nullable<boolean>;
  [FIELDS.PRODUCT_FEE]: Nullable<number>;
  [FIELDS.PRODUCT_FEE_PAYMENT]: Nullable<boolean>;
  [FIELDS.COMPLETION_DATE]: Nullable<string>;
  [FIELDS.VARIABLE_TERM_START_DATE]: Nullable<string>;
  [FIELDS.NUMBER_OF_PAYMENTS]: Nullable<string>;
  [FIELDS.FIXED_INTEREST_RATE]: Nullable<number>;
  [FIELDS.REVERT_MARGIN]: Nullable<number>;
  [FIELDS.LVR]: Nullable<string>;
};

export type BorrowerSection = ApplicantRelated<{
  [FIELDS.BORROWER_TITLE]: Nullable<string>;
  [FIELDS.BORROWER_LAST_NAME]: Nullable<string>;
  [FIELDS.BORROWER_FIRST_NAME]: Nullable<string>;
  [FIELDS.BORROWER_GENDER]: Nullable<string>;
  [FIELDS.BORROWER_DATE_OF_BIRTH]: Nullable<string>;
  [FIELDS.BORROWER_PHONE_HOME]: Nullable<number>;
  [FIELDS.BORROWER_PHONE_MOBILE]: Nullable<number>;
  [FIELDS.BORROWER_PHONE_WORK]: Nullable<number>;
  [FIELDS.BORROWER_EMAIL]: Nullable<string>;
  [FIELDS.BORROWER_ADDITIONAL_EMAIL]: Nullable<string>;
  [FIELDS.BORROWER_EMPLOYMENT_STATUS]: Nullable<string>;
  [FIELDS.BORROWER_TOTAL_CURRENT_INCOME]: Nullable<number>;
}>;

export type PepperReview = {
  [SUBDOMAINS.GENERAL]: GeneralSection;
  [SUBDOMAINS.MORTGAGE_PROPERTY]: MortgagePropertySection;
  [SUBDOMAINS.LOAN]: LoanSection;
  [SUBDOMAINS.BORROWER]: BorrowerSection;
};
